import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./CreditNote.css";
import { truncateToTwoDecimals } from "../../../../components/dms_common/DmsUtils";

interface CreditNoteData {
  id: string;
  amount: number;
  noteNumber: string;
  availableAmount: number;
  expired: boolean;
  endDate: string; 
}

interface CreditNoteProps {
  creditNotes?: CreditNoteData[];
  isOpen: boolean;
  onToggle: () => void;
}

const CreditNote: React.FC<CreditNoteProps> = ({
  creditNotes = [], // Default to empty array if undefined
  isOpen,
  onToggle
}) => {
  // Filter out any null or invalid notes
  const validCreditNotes = Array.isArray(creditNotes)
    ? creditNotes.filter(note =>
      note &&
      (note.id !== undefined && note.id !== null) &&
      (typeof note.amount === 'number')
    )
    : [];

  const isSingleNote = validCreditNotes.length === 1;

  return (
    <div className="credit-note-container">
      <div className="credit-note-header" onClick={isSingleNote ? undefined : onToggle}>
        <span className="credit-note-header-text">Credit Note</span>
        {!isSingleNote && (
          <ArrowDropDownIcon
            sx={{
              color: "#6E6969",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease"
            }}
          />
        )}
      </div>
      {(isSingleNote || isOpen) && (
        <div className="credit-note-list">
          {creditNotes.map((note) => (
            <div key={note.id} className="credit-note-item" style={note.expired ? { opacity: 0.3 } : {}}>
                             <div className="credit-note-detail">
                <span className="credit-note-label">Available Amount</span>
                <div className="credit-note-value">
                  ₹ {truncateToTwoDecimals(note.availableAmount)}
                </div>
              </div>
              <div className="credit-note-detail">
                <span className="credit-note-label">Total Amount</span>
                <div className="credit-note-value">
                  ₹ {truncateToTwoDecimals(note.amount)}
                </div>
              </div>
              <div className="credit-note-detail">
                <span className="credit-note-label">Credit Note No.</span>
                <div className="credit-note-value">{note.noteNumber}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreditNote;